<template>
  <div>
    <form @submit.prevent="onSubmit"
          @keydown="errors.clear($event.target.name)"
    >
      <div class="modal-form-block">
        <label for="descrizione">
          {{ trans.get('strlyt.description') }}
        </label>
        <input
            name="descrizione"
            type="text"
            v-model="form.descrizione"
            lang="it"
        />
        <span class="alert alert-danger"
              v-if="errors.has('descrizione')"
              v-text="errors.get('descrizione')"
        >
        </span>
      </div>
      <div class="modal-form-block">
        <label for="descrizione_estesa">
          {{ trans.get('strlyt.extended_description') }}
        </label>
        <input
            name="descrizione_estesa"
            type="text"
            v-model="form.descrizione_estesa"
            lang="it"
        />
        <span class="alert alert-danger"
              v-if="errors.has('descrizione')"
              v-text="errors.get('descrizione')"
        >
        </span>
      </div>
      <div class="modal-form-block my-6">
        <button class="w-1/3 mx-auto btn is-aitems-700"
                :class="isLoading && 'loader'"
                :disabled="errors.any()"
        >
          {{ trans.get('items.modal.crea') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import TranslationInput from "./utilities/TranslationInput";
import Errors from "../utilities/Errors";

export default {

  components: {
    TranslationInput
  },

  data() {
    return {
      form: {
        descrizione: '',
        descrizione_estesa: '',
      },
      errors: new Errors(),
      isLoading: false
    }
  },

  methods: {
    onSubmit() {
      this.isLoading = true;
      axios.post('/strings-layout-types', this.form)
          .then(({data}) => {
            this.$emit('strings_layout_type_has_been_created', data);
          })
          .catch(error => {
            console.log(error.response.data);
            this.errors.record(error.response.data.errors);
            this.isLoading = false;
          });
    }
  }
}
</script>

<style lang="scss" scoped>

.alert {

  @apply text-xs mt-1 capitalize;

}

.alert-danger {

  @apply text-red-400;

}

</style>